import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, SimpleChanges } from '@angular/core';
import { ButtonProps, LoadingButtonProps } from '@bl/components';
import { BlFrontendBaseComponent } from './bl-frontend-base.component';
import { toggleClass } from './helpers';

@Component({
  selector: 'bl-frontend-loading-button',
  template: '',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [],
})
export class BlFrontendLoadingButtonComponent extends BlFrontendBaseComponent<ButtonProps> {
  @Input() text: LoadingButtonProps['text'] = '';
  @Input() variant: LoadingButtonProps['variant'] = 'primary';
  @Input() disabled: LoadingButtonProps['disabled'] = false;
  @Input() type: LoadingButtonProps['type'] = 'button';
  @Input() fullWidth: LoadingButtonProps['fullWidth'] = false;
  @Input() density: LoadingButtonProps['density'] = 'regular';
  @Input() loading: LoadingButtonProps['loading'] = false;

  @Output() onclick = new EventEmitter<Event>();

  protected override getComponentName(): string {
    return 'LoadingButton';
  }

  protected override getProps(): LoadingButtonProps {
    return {
      text: this.text,
      variant: this.variant,
      disabled: this.disabled,
      type: this.type,
      fullWidth: this.fullWidth,
      density: this.density,
      loading: this.loading,
      onclick: (event: Event) => this.onclick.emit(event),
    };
  }

  protected override onChanges = (changes: SimpleChanges) => {
    this.handleRefElementWidth(changes);
  };

  handleRefElementWidth(changes: SimpleChanges): void {
    if ('fullWidth' in changes) {
      const condition = changes['fullWidth'].currentValue;
      toggleClass(this.ref.nativeElement, 'w-full', condition);
    }
  }
}
